import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";

// https://www.membug.com/note/72f48c5bbab40

// initial state
export const initialState = {
  loaded: false,
  loading: false,
  needsUpdate: false,
  data: []
};

export const menudataSlice = createSlice({
  name: "menudata",
  initialState,
  reducers: {
    setNeedsUpdate: (state, action) => {
      state.needsUpdate = action.payload;
    },
    setLoaded: (state, { payload }) => {
      state.loaded = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setData: (state, { payload }) => {
      state.loaded = true;
      state.needsUpdate = false;
      state.data = payload;
    },
    setError: state => {
      state.error = true;
    }
  }
});

// export the actions
export const {
  setLoading,
  setData,
  setError,
  setNeedsUpdate
} = menudataSlice.actions;

export const menudataSelector = state => state.menudata;

export default menudataSlice.reducer;

// fetch all items
export function fetchData() {
  return async dispatch => {
    dispatch(setLoading(true));
    axios
      .get(APPCONFIG.host + "api/lunchorder/appData", {
        withCredentials: true,
        timeout: APPCONFIG.axiosTimeout,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(setData(JSON.parse(response.data)));
        dispatch(setLoading(false));
      })
      .catch(er => {
        dispatch(setError());
      });
  };
}
